import {
  CUSTOMER_FILE_TYPES_SUCCESS,
  CUSTOMER_FILE_TYPES_FAILURE,
} from "../constants/actionTypes";

import API from "../../utility/axiosClient";

//Get customer file mapping
const onCustomerFileTypeSucces = (mappings) => {
  return {
    type: CUSTOMER_FILE_TYPES_SUCCESS,
    mappings,
  };
};
const onCustomerFileTypeFailure = (error) => {
  return {
    type: CUSTOMER_FILE_TYPES_FAILURE,
    error,
  };
};
export const GetCustomerFileType = () => {
  return async (dispatch) => {
    try {
      const res = await API.get("/api/customer-file-types/");
      dispatch(onCustomerFileTypeSucces(res.data.results));
    } catch (err) {
      if (err && err.response) {
        return dispatch(
          onCustomerFileTypeFailure({
            error: err,
          })
        );
      }
      dispatch(onCustomerFileTypeFailure({ error: err }));
    }
  };
};
